export default ({
  countryCode,
  postalCode,
  premiseNumber,
  premiseNumberSuffix,
  organisation,
  givenName,
  additionalName,
  familyName,
  thoroughfare,
  locality,
  administrativeArea,
}) => ({
  country_code: countryCode,
  locality: locality?.trim(),
  postal_code: postalCode?.toUpperCase(),
  address_line_1: `${thoroughfare?.trim()} ${premiseNumber?.toString().trim()}${
    premiseNumberSuffix ? ` ${premiseNumberSuffix?.trim()}` : ''
  }`,
  thoroughfare: thoroughfare?.trim(),
  premise_number: parseInt(premiseNumber, 10),
  premise_number_suffix: premiseNumberSuffix,
  organisation: organisation?.trim(),
  given_name: givenName,
  additional_name: additionalName,
  family_name: familyName,
  administrative_area: administrativeArea,
});
